import logo from "./logo.svg";
import {
  BrowserRouter,
  Switch,
  Route,
  Router,
  withRouter,
  useLocation
} from "react-router-dom";
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Header from "./Header";
import axios from "axios";
import { getToken, removeUserSession, setUserSession } from "./Utils/Common";
import PrivateRoute from "./Utils/PrivateRoute";
import "./OpenOrders.css";
import ShippedData from "./ShippedData";
import OpenOrders from "./OpenOrders";
import AddData from "./AddData";
import Dashboard from "./Dashboard";
import Login from "./Login";
import './Responsive.css';
import UpdatePOData from "./UpdatePOData";
import Add_Part_Dataset from "./Add_part_Dataset/Add_Part_Dataset";
import Morning_registration from "./aws_project/Morning_registration";
import MainPage from "./aws_project/Pages/MainPage";
import GetReport from "./aws_project/Pages/GetReport";
import { Data } from "./Pivot/Pivot";
import NewDashboard from "./NewDashboard/Dashboardnew";
import MultiLineChart from "./NewDashboard/LineGraph";
import VideoPlayer from "./Video_project/Video_Main";
import Production_entry from "./aws_project/Production_entry";
import Moulding_entry from "./Pages/Moulding_entry";
import Attendance from "./attendance_system/Attendance";
import Supply_chain_dashboard from "./Supply_chain/Supply_chain_dashboard";
import Attendance_details from "./attendance_system/Attendance_details";
import Raw_Material_Dataset from "./Supply_chain/Other_Expenses.js/Raw_material_dataset/Raw_Material_Dataset";
import History_Received_Supplies from "./Supply_chain/PO_Supplies/History_Received_Supples";
import History_Received_raw_Material from "./Supply_chain/PO_Raw_material/History_Received_raw_Material";
import { Data_Supply } from "./Supply_chain/Pivot_supply_chain/Pivot";
import Sidebar_SuppluChain from "./Supply_chain/Dashboard";
import Schedule from "./aws_project/Schedule/Create_Schedule";
import ManualSchedule from "./aws_project/Schedule/Create_Schedule_Manual";
import Scheduling from "./aws_project/Schedule/Scheduling";
import ActivityLog from "./aws_project/Schedule/Activitylog";
import Admin_dashboard from "./Admin_dashboard/Admin_dashboard";
import AdminRoute from "./Utils/AdminRoute";
import PublicRoute from "./Utils/PublicRoute";
import BOM_Dashboard from "./BOM/BOM_Dashboard";
import BOM_pivot from "./BOM/BOM";
import BOM_entry from "./BOM/Add_BOM";
import ManagerRoute from "./Utils/ManagerRoute";
import Footer from "./Footer/Footer";
import Attendance_report from "./attendance_system/Attendance_report";
import Mold_list from "./aws_project/Production/Mold_list";
import Production_dashboard from "./aws_project/Production/Production_dashboard";
import HamburgerMenu from "./MobileView/HamburgerMenu";
import New_ShiftReport from "./aws_project/Production/New_Shift_Reports";
import ShiftReport_All from "./aws_project/Production/All_Shift_Reports";
import Trial from "./aws_project/Production/Storage/Trial";
import Upholstery_Schedule from "./Pages/Upholstery_schedule";
import Upholstery_entry from "./Pages/Upholstery_entry";
import Graph_History_Received_raw_Material from "./Supply_chain/PO_Raw_material/Graph_History_Received_raw_Material";
import Add_Internal_Part_Dataset from "./Add_part_Dataset/Add_Internal_Part_Dataset";
import UnifiedReportDashboard from "./Report";
import Sidebar_Woodshop from "./Woodshop/Woodshop_dash";
import Maintenance_dashboard from "./aws_project/Maintenance/Maintenace_dashboard";
import Purchase_dashboard from "./Supply_chain/Purchase_requisition_form/Purchase_requisition_Dashboard";
import Parts_Inventory from "./aws_project/Schedule/Parts_Inventory/Parts_Inventory_Dashboard";
import Temp_Inventory from "./aws_project/Schedule/Parts_Inventory/Temporary_Inventory";
import Tentative_Schedule from "./aws_project/Schedule/Tentative_Schedule/Tentative_Schedule";
import ReturnParts from "./RGA/Return_Parts";
import MorningMeetingReport from "./aws_project/Morning_Report/MorningMeetingReport";
import MorningMeetingActivityLog from "./aws_project/Morning_Report/Morningmeetingactivitylog";
import ManagerApproval from './aws_project/Maintenance/ManagerApproval';
// ✅ FIXED: Single import for Maintenance components
import MaintenanceDashboard from './aws_project/Maintenance/Maintenace_dashboard';
import TicketDetail from './aws_project/Maintenance/TicketDetail';
import AllRequests from './aws_project/Maintenance/All_requests';
import ServiceTypeTable from './aws_project/Maintenance/ServiceTypeTable';
import Maintenance_ActivityLog from './aws_project/Maintenance/ActivityLog';
import MaintenanceForm from './aws_project/Maintenance/Maintenance_request';
import NewShiftReport from './aws_project/Maintenance/Daily_maintenance_Reports';
import ShiftReportAll from './aws_project/Maintenance/All_Maintenance_Reports';
import ProductionReport from './aws_project/Production/Production_Report/ProductionReport';

export const Host = '18.227.126.214';
export const host = '18.227.126.214';
export var token = (window.localStorage.getItem("acessToken"));


const App = () => {
  const location = useLocation();
  const hideFooter = location.pathname === '/login' || location.pathname === '/';
  const [PD, setPD] = useState(false);

  const [authLoading, setAuthLoading] = useState(true);
  useEffect(() => {
    const token = getToken();
    if (!token) {
      setAuthLoading(false);
      return;
    }

    axios
      .get(`https://` + Host + `/verifyToken?token=${token}`)
      .then((response) => {
        setUserSession(response.data.token, response.data.user);
      })
      .catch((error) => {
        removeUserSession();
      })
      .finally(() => {
        setAuthLoading(false);
      });
  }, []);

  if (authLoading && getToken()) {
    return <div className="content">Checking Authentication...</div>;
  }

  return (
    <div className="app-wrapper">
      <div className="app-container">
        <div className="app-header-section">
          <div class="headers" id="h">
            {!hideFooter && <Header />}
          </div>
          <div id="threeLines" hidden>
            {!hideFooter && <HamburgerMenu />}
          </div>
        </div>

        <div className="app-content-wrapper">
          <main className="app-main-content">
            <Switch>
              <PublicRoute exact path="/" redirectPath="/Admin_dashboard" component={Login} />
              <PrivateRoute exact path="/pivot" component={Data} />
              <PrivateRoute path="/Getreport" component={GetReport} />
              <PrivateRoute path="/moldingentry" component={Moulding_entry} />
              <PrivateRoute path="/NewDashboard" component={NewDashboard} restrictedToUpholstery={true} />
              <PrivateRoute path="/Adddata" component={AddData} />
              <PrivateRoute path="/Dashboard" component={withRouter(Dashboard)} />
              <PrivateRoute path="/reaminedparts" component={OpenOrders} />
              <PrivateRoute path="/shippedparts" component={ShippedData} />
              <PrivateRoute path="/UpdatePOData" component={UpdatePOData} />
              <PrivateRoute path="/Night" component={Morning_registration} />
              <PrivateRoute path="/Nightdata" component={Morning_registration} />
              <PrivateRoute path="/RetrieveData" component={MainPage} />
              <PrivateRoute path="/openorder" component={OpenOrders} />
              <PublicRoute path="/login" redirectPath="/Admin_dashboard" component={Login} />
              <PrivateRoute path="/Morning" component={Production_entry} />
              <PrivateRoute path="/graph" component={MultiLineChart} />
              <PrivateRoute path="/attendance" component={Attendance} />
              <PrivateRoute path="/attendanceDetails" component={Attendance_details} />
              <PrivateRoute path="/InternalPartSet" component={Add_Internal_Part_Dataset} />
              <PrivateRoute path="/PartsInventory" component={Parts_Inventory} />

              <ManagerRoute path="/rawmaterial" component={Raw_Material_Dataset} adminOnly alternate="/NewDashboard" />
              <ManagerRoute path="/Historyrawmaterial" component={History_Received_raw_Material} adminOnly alternate="/NewDashboard" />
              <ManagerRoute path="/Historyreceivedsupplies" component={History_Received_Supplies} adminOnly alternate="/NewDashboard" />
              <PrivateRoute path="/Supply_Pivot" component={Data_Supply} alternate="/NewDashboard" />
              <ManagerRoute path="/Suppluchain" component={Sidebar_SuppluChain} adminOnly alternate="/NewDashboard" />
              <ManagerRoute path="/attendancereport" component={Attendance_report} adminOnly alternate="/attendance" />
              <ManagerRoute path="/addpartdataset" component={Add_Part_Dataset} adminOnly alternate="/attendance" />
              <PrivateRoute path="/PurchaseRequest" component={Purchase_dashboard} />

              <PrivateRoute path="/Scheduling" component={Scheduling} />
              <PrivateRoute path="/SchedulingEntry" component={Schedule} />
              <PrivateRoute path="/MSchedulingEntry" component={ManualSchedule} />

              <AdminRoute path="/Admin_dashboard" component={Admin_dashboard} adminOnly restrictedToUpholstery={true} alternate="/NewDashboard" />
              <AdminRoute path="/BOM" component={BOM_Dashboard} adminOnly alternate="/NewDashboard" />
              <AdminRoute path="/BOMPivot" component={BOM_pivot} adminOnly alternate="/NewDashboard" />
              <AdminRoute path="/Add_BOM" component={BOM_entry} adminOnly alternate="/NewDashboard" />

              <PrivateRoute path="/Production/MoldList" component={Mold_list} />
              <PrivateRoute path="/Production/shiftReport" component={New_ShiftReport} />
              <PrivateRoute path="/Production/shiftReports/All" component={ShiftReport_All} />
              <PrivateRoute path="/Production" component={Production_dashboard} />
              <PrivateRoute path="/Upholstery_Schedule" component={Upholstery_Schedule} />
              <PrivateRoute exact path="/Graph_RRM" component={Graph_History_Received_raw_Material} />

              {/* ✅ FIXED: Maintenance routes - MORE SPECIFIC ROUTES FIRST */}
              <PrivateRoute path="/maintenance/request/:id" component={TicketDetail} />
              <PrivateRoute path="/maintenance/requests" component={AllRequests} />
              <PrivateRoute path="/maintenance/new-request" component={MaintenanceForm} />
              <PrivateRoute path="/maintenance/reports" component={ShiftReportAll} />
              <PrivateRoute path="/maintenance/new-report" component={NewShiftReport} />
              <PrivateRoute path="/maintenance/service-types" component={ServiceTypeTable} />
              <PrivateRoute path="/maintenance/activity-log" component={Maintenance_ActivityLog} />
              <PrivateRoute path="/maintenance" component={MaintenanceDashboard} />

              <PrivateRoute exact path="/Temporary_Inventory" component={Temp_Inventory} />
              <PrivateRoute exact path="/Tentative_schedule" component={Tentative_Schedule} />
              <PrivateRoute path="/maintenance-approvals" component={ManagerApproval} />
              {/*Trial Routes*/}
              <ManagerRoute path="/UnifiedReportDashboard" component={UnifiedReportDashboard} adminOnly alternate="/NewDashboard" />
              <PrivateRoute path="/MorningReport" component={MorningMeetingReport} />
              <Route exact path="/upholstery_Entry" component={Upholstery_entry} />
              <PrivateRoute path="/Woodshop_Dashboard" restrictedToUpholstery={false} component={withRouter(Sidebar_Woodshop)} />
              <PrivateRoute path="/RGA/Return_Parts" component={ReturnParts} />
              <PrivateRoute path="/ActivityLog" component={ActivityLog} />
              <PrivateRoute path="/morning-meeting-activity-log" component={MorningMeetingActivityLog} />
              <PrivateRoute path="/production-report" component={ProductionReport} />
            </Switch>
          </main>
        </div>

        {!hideFooter && <Footer />}
      </div>
    </div>
  );
}

export default withRouter(App);